import React, { useCallback, useState } from 'react';
import { useService } from '../../../../services/services';
import { downloadFile } from '../../../../services/utils';
import Spinner from '../../../../components/common/spinner';
import { ModelItem } from '../list';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faFileExcel } from '@fortawesome/pro-regular-svg-icons';
import css from './links.module.css';

interface Props {
  items: ModelItem[];
}

export default function DownloadLinks({ items }: Props) {
  return (
    <div className={css['links']}>
      {items.map((item: ModelItem) => {
        return item.fileId ? (
          <DownloadLink item={item} key={`link-${item.id}`} />
        ) : (
          ''
        );
      })}
    </div>
  );
}

interface DownloadLinkProps {
  item: ModelItem;
}

function DownloadLink({ item }: DownloadLinkProps) {
  const { fileService } = useService();
  const [disabled, setDisabled] = useState(false);

  const download = useCallback(
    (id: string, name = 'file.pdf') => {
      setDisabled(true);
      fileService.download(id).subscribe((file: Blob) => {
        downloadFile(file, name);
        setDisabled(false);
      });
    },
    [setDisabled, fileService]
  );

  return (
    <div className={css['field']}>
      <span
        className={`${css['link']} ${disabled ? css['disabled'] : ''}`}
        onClick={() => download(item.fileId, item.fileName)}
      >
        {item.name}
        {disabled ? (
          <Spinner visible={true} size="sm" className={css['spinner']} />
        ) : (
          <>
            <FontAwesomeIcon icon={faArrowDown} className={css['small']} />
            <FontAwesomeIcon icon={faFileExcel} className={css['big']} />
          </>
        )}
      </span>
    </div>
  );
}
